import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=72e6d940"
import script from "./tabs.vue?vue&type=script&lang=js"
export * from "./tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports